import { Box, Grid, Stack, Typography } from "@mui/material";
import "./ServicesGeneralList.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ServicesGeneralList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();



  const servicesTypes = [
    {
      id: "servicesOptimizePowers",
      name: "Optimizador de potencias",
      icon: "t-icon-electricite-big",
      handleClick: () =>
        navigate(process.env.REACT_APP_SERVICES_POWER_OPTIMIZER!),
    },
    {
      id: "servicesOptimizeGasFlow",
      name: "Optimizador de caudal",
      icon: "t-icon-gaz-big",
      handleClick: () =>
        navigate(process.env.REACT_APP_SERVICES_GASFLOW_OPTIMIZER!),
    },
    //  {
    //   id: "servicesMarketReports",
    //   name: "Informes de mercado",
    //   icon: "t-icon-Newspaper",
    //   handleClick: () =>
    //     navigate(process.env.REACT_APP_SERVICES_MARKET_REPORTS!),
    // },
    // {
    //   id: "managementsUpdateDirectDebit",
    //   name: "Realizar coberturas",
    //   icon: "t-icon-Bank",
    //   handleClick: () =>
    //     navigate(process.env.REACT_APP_SERVICES_COVERAGES!),
    // },
    {
      id: "managementsUpdateContact",
      name: "Simulador de facturas",
      icon: "t-icon-chart-bar",
      handleClick: () =>
        navigate(process.env.REACT_APP_SERVICES_INVOICE_SIMULATOR!),
    },
  ];

  return (
    <Box
      component="section"
      className="last-services"
      sx={{ paddingTop: { xs: "3.5rem", md: "5rem" } }}
      paddingBottom={{ xs: "2.5rem", md: "5rem" }}
    >
      <Typography
        component="h3"
        variant="h3"
        sx={{ mb: { md: "2.5rem", xs: "1.5rem" } }}
      >
        {t("Servicios.¿A qué servicio deseas acceder?")}
      </Typography>
      <Grid container spacing={"1.25rem"}>
        {servicesTypes.map(({ id, name, icon, handleClick }) => (
          <Grid item key={id} xs={12} md={4}>
            <Stack
              boxShadow="0px 3px 5px 0px rgba(55, 70, 73, 0.20)"
              bgcolor="background.default"
              paddingY="2rem"
              paddingX="1.25rem"
              borderRadius="16px"
              direction={{ xs: "row", md: "column" }}
              gap={{ xs: "1.5rem", md: "2rem" }}
              key={icon}
              minHeight={{ xs: "55px", md: "130px" }}
              onClick={() => handleClick && handleClick()}
              sx={{ cursor: "pointer" }}
              data-testid={id}
            >
              <Typography
                component="p"
                variant="h1"
                sx={{ color: "primary.main" }}
              >
                <span className={icon} />
              </Typography>
              <Stack>
                <Typography
                  component="h3"
                  variant="subtitle1"
                  sx={{ color: "grey.700" }}
                >
                  {t(`Servicios.${name}`)}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ServicesGeneralList;
